
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "AutoWidthOption"
})
export default class extends Vue {
  @Prop({ required: true }) private value!: boolean;

  get autoWidth() {
    return this.value;
  }

  set autoWidth(value) {
    this.$emit("input", value);
  }
}
